<template>
	<v-dialog v-model="equity_edit_form_dialog_status" persistent >
	    <v-card>
		    <v-card-title>
		      <span class="text-h5">Edit Form</span>
		    </v-card-title>
		    <v-card-text>
			    <v-container>
			      	<v-form ref="form" id="equity_edit_from_id" v-model="valid" @submit.prevent lazy-validation>
				        <v-row>
					        <v-col cols="12" sm="1" md="4">
					            <label>Exchange</label>
					            <v-select 
					              ref="form_attrs"
					              name="exchange"
					              v-model="selected_exchange"
					              :items="exchange_items"
					              item-value="name"
					              item-text="name"
					              placeholder="Exchange"
					              @change="getExchangeData($event)"
					            ></v-select>
					        </v-col>
					        <v-col cols="12" sm="6" md="4">
					            <label>Owner</label>
					            <v-select
					                ref="owner"
					                name="owner"
					                v-model="selectOwner"
					                :items="get_member_list"
					                item-value="name"
					                item-text="name"
					                @change="removeError('owner')"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{owner_warning_msg}}</p>
					        </v-col>
					        <v-col cols="12" sm="1" md="4">
					            <label>Security Name</label>
					            <v-select
					                ref="security_name"
					                name="security_name"
					                v-model="selectSecurityName"
					                :items="get_security_list"
					                item-value="name"
					                item-text="name"
					                @change="removeError('security_name')"
					                placeholder=""
					            ></v-select>
					            <p style="color: red !important">{{security_name_warning_msg}}</p>
					        </v-col>
					        <v-col cols="12" sm="6" md="4">
					          	<label>No Of Shares</label>
					            <v-text-field name="no_of_shares" ref="no_of_shares" v-model ="get_equity_edit_form_data.equity_row_item_detail.no_of_shares"></v-text-field>
					        </v-col>
					        <v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_1_select_box_status">Nominee 1 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_1')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 1 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_1')">remove dropdown</a></label>
					            <v-text-field name="nominee_1" ref="nominee_1" v-model="selectNominee_1" v-if="!nominee_1_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_1"
					                name="nominee_1"
					                v-model="selectNominee_1"
					                :items="nominee_list"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
					        </v-col>
				            <v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_2_select_box_status">Nominee 2 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_2')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 2 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_2')">remove dropdown</a></label>
					            <v-text-field name="nominee_2" ref="nominee_2" v-model="selectNominee_2" v-if="!nominee_2_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_2"
					                name="nominee_2"
					                v-model="selectNominee_2"
					                :items="nominee_list"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
				            </v-col>
				            <v-col cols="12" sm="6"  md="4">
					          	<label v-if="!nominee_3_select_box_status">Nominee 3 <a href="javascript:void(0)" v-on:click="chooseNominee('nominee_3')" >choose from dropdown</a></label>
					          	<label v-else>Nominee 2 <a href="javascript:void(0)" v-on:click="typeNominee('nominee_3')">remove dropdown</a></label>
					            <v-text-field name="nominee_3" ref="nominee_3" v-model="selectNominee_3" v-if="!nominee_3_select_box_status"></v-text-field>
					            <v-select v-else
					                ref="nominee_3"
					                name="nominee_3"
					                v-model="selectNominee_3"
					                :items="nominee_list"
					                item-value="id"
					                item-text="name"
					                placeholder=""
					            ></v-select>
				            </v-col>
				        </v-row>
				    </v-form>    
			    </v-container>
		    </v-card-text>
		    <v-card-actions>
		      <v-spacer></v-spacer>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="close"
		      >
		        Cancel
		      </v-btn>
		      <v-btn
		        color="blue darken-1"
		        text
		        @click="save"
		      >
		        Save
		      </v-btn>
		    </v-card-actions>
	    </v-card>
	</v-dialog>
</template>
<script>
    import ApiService from '@/api/api.service';
    export default {
	  	props: ['equity_edit_form_dialog_status', 'get_equity_edit_form_data', 'get_member_list'],
	  	data: function () {
		    return { 
		    	selectNominee_1:null,
		    	selectNominee_2:null,
		    	selectNominee_3:null,
		    	selectOwner:null,
		    	selectSecurityName:null,
		    	get_security_list:[],
		    	selected_exchange:null,
			    exchange_items:[{id:'BSE', name:'BSE'}, {id:'NSE', name:'NSE'}],
			    owner_warning_msg_status:false,
			    security_name_warning_msg_status:false,
			    security_name_warning_msg:'',
			    owner_warning_msg:'',
			    nominee_list:[],
			    nominee_1_select_box_status:false,
			    nominee_2_select_box_status:false,
			    nominee_3_select_box_status:false,
			    getFormData:'',
			    valid:null,
			    security_list:[],
		    }
		},

	    mounted (){
			
			this.$loading(true)
	    	this.selected_exchange =this.get_equity_edit_form_data.equity_row_item_detail.exchange;
	    	this.selectNominee_1 =this.get_equity_edit_form_data.equity_row_item_detail.nominee_1;
	    	this.selectNominee_2 =this.get_equity_edit_form_data.equity_row_item_detail.nominee_2;
	    	this.selectNominee_3 =this.get_equity_edit_form_data.equity_row_item_detail.nominee_3;
	    	this.getExchangeData(this.get_equity_edit_form_data.equity_row_item_detail.exchange);
			this.selected_exchange = this.get_equity_edit_form_data.equity_row_item_detail.exchange;

	        this.get_member_list.forEach(owner_detail => {
	            if(this.get_equity_edit_form_data.equity_row_item_detail.owner !=null && this.get_equity_edit_form_data.equity_row_item_detail.owner == owner_detail.name){
	            	this.selectOwner = owner_detail.name
	              	this.owner_warning_msg        = '' 
	              	this.owner_warning_msg_status = true	
	            }
	            else{
					if(this.get_equity_edit_form_data.id !=0){	
                       this.nominee_list.push({'id':owner_detail.name, 'name':owner_detail.name});
					}
	            }
	        })
	        if(this.owner_warning_msg_status == false){
	            this.owner_warning_msg = 'Uploaded owner name ('+this.get_equity_edit_form_data.equity_row_item_detail.owner+') is not found in member list. Kindly choose from above list'
	        }	   
	    },

	    methods: {
	    	getExchangeData(event){
	    		this.get_security_list = [];
	    		let cognito_idp = atob(localStorage.getItem('cognito_idp'));
	    		let val = (event == 'BSE') ? 'bse' : 'nse';
    			ApiService.setHeader();
		        ApiService.post('get-security-list',{
		          aws_cognito_id: cognito_idp,
		          exchange_id: val,
		          bond_type:'equity_share'
		        }).then( (response) => {
		        	response.data.data.forEach(security_detail => {
		           		this.get_security_list.push({'id':security_detail.id, 'name':security_detail.company_name});
		           		this.get_security_list.forEach(security_detail => {
				            if(this.get_equity_edit_form_data.equity_row_item_detail.security_name == security_detail.name){
				            	this.selectSecurityName = security_detail.name
				              	this.security_name_warning_msg        = '' 
				              	this.security_name_warning_msg_status = true
				            }
				        })
				        if(this.security_name_warning_msg_status == false){
				            this.security_name_warning_msg = 'Uploaded security name ('+this.get_equity_edit_form_data.equity_row_item_detail.security_name+') is not found in list. Kindly choose from above list'
				        }
						this.$loading(false)
			        });
		        })
	    	},

	    	chooseNominee(field_name){
	    		if(field_name == 'nominee_1'){
	    			this.nominee_1_select_box_status = true
	    		}
	    		else if(field_name == 'nominee_2'){
                    this.nominee_2_select_box_status = true
	    		}
	    		else if(field_name == 'nominee_3'){
                    this.nominee_3_select_box_status = true
	    		}
	    		else{

	    		}
	    	},

	    	typeNominee(field_name){
	    	    if(field_name == 'nominee_1'){
	    			this.nominee_1_select_box_status = false
	    		}
	    		else if(field_name == 'nominee_2'){
                    this.nominee_2_select_box_status = false
	    		}
	    		else if(field_name == 'nominee_3'){
                    this.nominee_3_select_box_status = false
	    		}
	    		else{

	    		}	
	    	},

	    	firstDialog(){
	           this.modal_open_status = false;
	           this.csv_dialog        = true;
	    	},

	    	finalSubmit(){ 

	    	},

	    	removeError(type){
		        if(type == 'security_name'){
		          this.security_name_warning_msg = ''
		        }
		        else if(type == 'owner'){
		          this.owner_warning_msg = ''
		        }
		    },

		    close(){
                this.$emit('getEquityUpdatedFormData', false)
		    },

		    save(e){
				this.getFormData      = document.querySelector("#equity_edit_from_id"); 
				let is_security_name_valid = false;
				let is_account_owner_valid = false;
				let updated_owner  = this.get_equity_edit_form_data.owner
				let updated_security_name  = this.get_equity_edit_form_data.security_name
				this.get_security_list.forEach(security_detail => {
					if(this.getFormData.security_name.value == security_detail.name){
						is_security_name_valid = true
					}
				})

				this.get_member_list.forEach(owner_detail => {
					if(this.getFormData.owner.value == owner_detail.name){
                       is_account_owner_valid = true
					}
				})

				if(this.getFormData.owner.value == ""){
                    is_account_owner_valid = false
				}
				else{
					updated_owner = this.getFormData.owner.value
				}

				if(this.getFormData.security_name.value == ""){
                    is_security_name_valid = false
				}
				else{
					updated_security_name = this.getFormData.security_name.value
				}
                let form_array_object = {'exchange':(this.getFormData.exchange.value), 'owner':updated_owner, 'security_name':updated_security_name,
				'no_of_shares':this.getFormData.no_of_shares.value, 
				'nominee_1':this.getFormData.nominee_1.value, 
				'nominee_2':this.getFormData.nominee_2.value, 
				'nominee_3':this.getFormData.nominee_3.value, is_account_owner_valid:is_account_owner_valid, is_security_name_valid:is_security_name_valid}
                this.$emit('getEquityUpdatedFormData', form_array_object)
		    }
	    }
    }
</script>